module.exports = __webpack_public_path__ + "static/windturbine-739a98c34b6f8d93f9381aaadb784dde.jpg";